import { IAppSetting } from '@addins/core/core';
import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { AppSettingProviderService } from '@services/settings';
import { filter, first } from 'rxjs/operators';
import { INavigationProvider } from '../../schema/interfaces/INavigationProvider';
import { ProviderName } from '../../schema/provider-name';
import { GoogleMapsProviderService } from '../google-maps-provider/google-maps-provider.service';
import { SygicProviderService } from '../sygic-provider/sygic-provider.service';
import { TomTomProviderService } from '../tom-tom-provider/tom-tom-provider.service';
import { WazeProviderService } from '../waze-provider/waze-provider.service';

@Injectable()
export class ExternalItineraryProviderService {
  private itineraryProviders: string[];
  get providers(): string[] {
    return this.itineraryProviders;
  }

  private _currentItineraryProvider: IAppSetting<string> = null;
  get currentItineraryProvider(): IAppSetting<string> {
    return this._currentItineraryProvider;
  }

  constructor(
    private sygicProvider: SygicProviderService,
    private tomTomProvider: TomTomProviderService,
    private wazeProvider: WazeProviderService,
    private googleMapsProvider: GoogleMapsProviderService,
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private appSettingsProvider: AppSettingProviderService
  ) {}

  setup() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => this.onProfileReady());
  }

  private onProfileReady() {
    this.itineraryProviders = this.profileReader
      .getComponentConfig('Ext-Itinerary', 'providers', [ProviderName[ProviderName.sygic]])
      .filter(providerName => ProviderName[providerName] !== undefined);

    const defaultExtItinerary: string = this.profileReader.getComponentConfig('Ext-Itinerary', 'defaultProvider', 'none');
    this.appSettingsProvider
      .getSetting<string>('DefaultExtItineraryProvider', defaultExtItinerary, true)
      .subscribe(appSetting => (this._currentItineraryProvider = appSetting));
  }

  get(providerName: ProviderName): INavigationProvider {
    switch (providerName) {
      case ProviderName.waze:
        return this.wazeProvider;

      case ProviderName.sygic:
        return this.sygicProvider;

      case ProviderName.tomtom:
        return this.tomTomProvider;

      case ProviderName.googlemaps:
        return this.googleMapsProvider;
    }
  }
}
